<template>
    <v-modal
        title="Add fields"
        @close="handleClose"
        size="small">
        <div slot="contents">
            <div class="modal-content">
                <p class="stack-m">Select the fields you want to include in your export.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input
                            v-model="searchValue"
                            label="Search fields"/>
                    </div>
                </div>
            </div>
            <div class="modal-content is-scrollable">
                <ol class="list list-group list-divided"
                    v-for="(field, index) in fieldsList">
                    <li class="list-item cursor-pointer stack-m">
                        <v-checkbox
                            :key="`${field.value}-${index}`"
                            :value="field.value"
                            :selected="field.selected"
                            @input="() => toggleField(index)">
                            <template slot="label">
                                <v-separated :list="field.pathLabel" class="display-flex align-items-center"/>
                            </template>
                        </v-checkbox>
                    </li>
                </ol>
            </div>
        </div>
        <template slot="actions">
            <r-button type="primary" @click="update">Apply</r-button>
        </template>
        <template slot="left-actions">
            <r-button @click="resetFields">Revert to default</r-button>
        </template>
    </v-modal>
</template>

<script>
    import _ from '@/common/helpers';
    import vModal from '@/components/modal/v-modal';
    import {vCheckbox} from '@/components/form';
    import vSeparated from '@/components/v-separated';
    import FilterSet from '@/components/query/filter-set';


    export default {
        name: 'fields-list-modal',
        components: {
            vModal,
            vCheckbox,
            vSeparated,
        },
        props: {
            // all available resource fields
            availableFields: {
                type: Array,
                required: true,
            },
            // model fields
            fields: {
                type: Array,
                required: true,
            },
            isVisible: {
                type: Boolean,
                required: true,
            },
            defaultFields: Array,
        },
        data() {
            return {
                searchValue: '',
                initSelectedFields: this.fields.slice(0),
                selectedFields: this.fields.slice(0),
            };
        },
        computed: {
            fieldsList() {
                const selected = this.initSelectedFields;
                const available = this.availableFields.filter(field => !selected.includes(field));

                const fields = [
                    ...selected,
                    ...available,
                ].map((field) => {
                    const pathLabel = field
                        .split(FilterSet.delimiter)
                        .map(_.unCamelCase);
                    return {
                        value: field,
                        pathLabel,
                        selected: this.selectedFields.includes(field) ? field : false,
                    };
                });

                const searchValue = this.searchValue.toLowerCase();

                const results = searchValue
                    ? fields.filter(
                        ({value}) => !!(
                            value.toLowerCase().includes(searchValue)
                        ),
                    )
                    : fields;
                return results.length ? results : fields;
            },
        },
        methods: {
            resetFields() {
                this.searchValue = '';
                this.selectedFields = [...this.defaultFields];
            },
            update() {
                this.$emit('update', this.selectedFields.slice(0));
                this.$emit('close');
            },
            toggleField(index) {
                const {value, selected} = this.fieldsList[index];
                const fields = this.selectedFields.slice(0);

                if (selected) {
                    fields.splice(fields.indexOf(value), 1);
                } else {
                    fields.push(value);
                }
                this.selectedFields = fields;
            },
            handleClose() {
                this.$emit('close');
                this.$nextTick(() => {
                    this.selectedFields = this.fields.slice(0);
                    this.initSelectedFields = this.fields.slice(0);
                    this.searchValue = '';
                });
            },
        },
        watch: {
            fields(fields) {
                this.selectedFields = fields.slice(0);
                this.initSelectedFields = fields.slice(0);
            },
        },
    };
</script>
